/**
 * Badge do carrinho — visibilidade e feedback.
 *
 * O contador é atualizado por AJAX (theme.js troca só o texto de
 * [data-cart-count], sem re-renderizar o header). Este observer roda por cima
 * disso, independente de quem fez a alteração, e cuida de duas coisas:
 *
 *   1. is-empty  → esconde o badge quando o carrinho está zerado. Mostrar "0"
 *                  comunica carrinho vazio; o badge só deve existir quando há
 *                  algo esperando a cliente.
 *   2. is-bump   → pop de escala quando o número aumenta, para o olho registrar
 *                  que o item entrou (o cart drawer nem sempre abre).
 *
 * Cobre os três pontos onde o badge aparece: header desktop, header mobile e a
 * bottom bar. A bottom bar mantém o próprio observer de `is-long`.
 */
(function () {
  var BUMP_MS = 420;

  function parseCount(text) {
    var n = parseInt((text || '').replace(/\D/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  function enhance(bubble) {
    if (bubble.dataset.bubbleEnhanced) return;
    var value = bubble.querySelector('[data-cart-count]');
    if (!value) return;
    bubble.dataset.bubbleEnhanced = 'true';

    var previous = parseCount(value.textContent);
    var timer;

    function sync() {
      var count = parseCount(value.textContent);
      bubble.classList.toggle('is-empty', count === 0);

      if (count > previous) {
        bubble.classList.remove('is-bump');
        // reflow força o restart da animação quando dois itens entram seguidos
        void bubble.offsetWidth;
        bubble.classList.add('is-bump');
        clearTimeout(timer);
        timer = setTimeout(function () {
          bubble.classList.remove('is-bump');
        }, BUMP_MS);
      }
      previous = count;
    }

    sync();
    new MutationObserver(sync).observe(value, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  function scan() {
    document.querySelectorAll('.cart-count-bubble').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Sections re-renderizadas pelo theme editor / Section Rendering API trazem
  // badges novos, que precisam ser reconectados.
  document.addEventListener('shopify:section:load', scan);
})();
